<template>
  <modal
  v-if="currentUser && currentUser.userId"
  name="join-room-modal"
  height="auto"
  :pivot-y="0.3"
  :adaptive="true"
  :width="recentConferences.length ? 817 : 428">
    <div class="JoinRoom__wrapper">
      <div class="JoinRoom__new-conf-container">
        <div class="JoinRoom__title">
          Join Someone Else's Call
        </div>
        <div class="JoinRoom__description">
          Please enter the @username/ID and unique PIN of the conference organizer
        </div>
        <form name="joinRoom">
          <div class="Grid-row">
            <div class="form-label">
              ID
            </div>
            <input
              v-focus
              type="text"
              name="id"
              placeholder="Enter ID of Conference Call"
              v-model="conference.id"
              class="field"
              :class="{'is-danger': errors.has('id')}"
              v-validate="'required'"
              data-vv-delay="500"
              data-vv-as="ID"
              ref="username"
              @keyup.enter="$refs.pin.focus()"
              required>
            <span v-show="errors.has('id')"
                  class="form-help is-danger">
            {{ errors.first('id') }}
          </span>
          </div>
          <div class="Grid-row">
            <div class="form-label">
              PIN
            </div>
            <input
              type="text"
              name="pin"
              placeholder="Enter PIN of Conference Call"
              v-model="conference.pin"
              class="field"
              :class="{'is-danger': errors.has('pin')}"
              v-validate="'required'"
              data-vv-delay="500"
              data-vv-as="PIN"
              required
              ref="pin"
              @keyup.enter="submit">
            <span v-show="errors.has('pin')"
                  class="form-help is-danger">
            {{ errors.first('pin') }}
          </span>
          </div>
          <div class="Grid-row">
            <div class="form-actions pull-right">
              <a @click="$modal.hide('join-room-modal')"
                 class="cancel-btn">cancel</a>
              <a @click="submit"
                 class="submit-btn">join</a>
            </div>
          </div>
        </form>
      </div>
      <div v-if="recentConferences.length"
           class="JoinRoom__recent-conf-container">
        <div class="JoinRoom__title">
          Or Join Recent Conference Room
        </div>
        <div class="JoinRoom__recent-conf-list">
          <div class="JoinRoom__recent-conf-element"
               @click="joinRecent(conf)"
               v-for="conf in recentConferences">
            <img class="JoinRoom__recent-conf-avatar"
                 :src="conf.avatarUrl"
                 v-fallback-src="'../../../../../static/images/default-user-avatar.jpg'"/>
            <div class="JoinRoom__recent-conf-username">
              @{{ conf.username }}
            </div>
            <div class="JoinRoom__recent-conf-pin">
              {{ conf.conferencePin }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
  export default {
    name: 'JoinRoom',
    data() {
      return {
        conference: {
          id: null,
          pin: null
        }
      };
    },
    computed: {
      recentConferences() {
        return this.currentUser && this.currentUser.userId ? JSON.parse(
          localStorage.getItem(`recent-conferences-${this.currentUser.userId}`)
        ) || [] : [];
      },
      currentUser() {
        return this.$store.getters.currentUser;
      }
    },
    methods: {
      submit() {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.$router.push({
              name: 'Room',
              params: {
                username: this.conference.id,
                pin: this.conference.pin
              }
            });
          } else {
            this.$refs.username.focus();
          }
        });
      },
      joinRecent(conf) {
        this.$router.push({
          name: 'Room',
          params: {
            username: conf.username,
            pin: conf.conferencePin
          }
        });
      }
    }
  };
</script>

<style scoped lang="scss">
  @import 'style.scss';
</style>



// WEBPACK FOOTER //
// join-room.modal.vue?8030fe66